import { VBTooltip } from 'bootstrap-vue'

export default {
  props: {
    // The mixin requires the component to receive the parcel prop,
    // as this is where the error information is located.
    parcel: {
      type: Object,
      required: true,
    },
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    /**
     * Processes the raw error array from the parcel and creates an
     * efficient lookup map, grouping errors by the field they apply to.
     * Example output: { 'buyer_name': [{ message: '...' }], 'description': [...] }
     */
    issuesMap() {
      const errors = this.parcel?.status_info?.errors ?? []

      return errors.reduce((acc, error) => {
        const field = error?.field
        if (field) {
          if (!acc[field]) {
            acc[field] = []
          }
          acc[field].push(error)
        }
        return acc
      }, {})
    },
  },
  methods: {
    /**
     * Gets the CSS class for a form input based on its validation status.
     * @param {string} fieldName - The name of the field (e.g., 'buyer_name').
     */
    getIssueClass(fieldName) {
      const issues = this.issuesMap[fieldName]
      if (issues && issues.length > 0) {
        // Assumes the first error's type determines the class
        return 'input-warning'
        // return issues[0].type === 'warning' ? 'input-warning' : 'is-invalid'
      }
      return null
    },
    /**
     * Gets the error message for a field to display in a tooltip.
     * @param {string} fieldName - The name of the field.
     */
    getIssueMessage(fieldName) {
      const issues = this.issuesMap[fieldName]
      if (issues && issues.length > 0) {
        // Joins messages if a field has multiple errors
        return issues.map(e => e.message).join(', ')
      }
      return ''
    },
  },
}
